import React, { useState } from 'react';
import Constant from '../../Constant';
import GraphCom from './GraphCom';
import FadeInSection from '../FadeInSection';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { motion } from 'framer-motion';

function TopInvestment() {
  const [activeTab, setActiveTab] = useState('SUKUK');

  const investments = {

    SUKUK: [
      // { name: "Lotus Halal Fixed Income Fund A", start: "1.12", end: "3.22" },
      // { name: "Lotus Halal Fixed Income Fund B", start: "1.12", end: "3.22" },
      // { name: "Lotus Halal Fixed Income Fund C", start: "1.12", end: "3.22" },
      // { name: "Lotus Halal Fixed Income Fund D", start: "1.12", end: "3.22" }, 
      // { name: "Lotus Halal Fixed Income Fund E", start: "1.12", end: "3.22" },
      // { name: "Lotus Halal Fixed Income Fund F", start: "1.12", end: "3.22" },

      { name: "Lotus Halal Fixed Income Fund", start: "1.12", end: "3.22" },
      { name: "Sukuk Fund A", start: "1.50", end: "3.80" },
      { name: "Sukuk Fund B", start: "0.95", end: "2.90" },
      { name: "Sukuk Fund C", start: "1.30", end: "3.10" },
      { name: "Sukuk Fund D", start: "1.20", end: "3.50" },
      { name: "Sukuk Fund E", start: "1.40", end: "3.00" },
      // { name: "Sukuk Fund F", start: "1.40", end: "3.00" },
    ],
    MURABAHA: [
      { name: "Murabaha Fund A", start: "1.20", end: "3.50" },
      { name: "Murabaha Fund B", start: "1.10", end: "3.00" },
      { name: "Murabaha Fund C", start: "1.30", end: "3.20" },
      { name: "Murabaha Fund D", start: "1.00", end: "2.80" },
      { name: "Murabaha Fund E", start: "1.25", end: "3.40" },
      { name: "Murabaha Fund F", start: "1.15", end: "3.10" },
    ],
  };

  const descriptions = {
    SUKUK: [
      { text: "Asset-backed, not debt-based." },
      { text: "Low-risk and ideal for stable, long-term returns." },
      { text: "Example: Lotus Halal Fixed Income Fund." },
    ],
    MURABAHA: [
      { text: "Earn returns from trade financing." },
      { text: "Fixed markups, no interest." },
    ],
  };

  return (
    <FadeInSection>
      <div className="px-6 sm:px-24 py-16">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-[24px] sm:text-[44px] text-text-color1 font-[400] mb-4 sm:w-[45%]"
        >
          Explore our <span className={Constant.linearColor}>Rewarding Ethical</span> Investment Opportunities
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
          viewport={{ once: true }}
          className="text-[14px] mb-10 font-[500] text-text-color1 sm:text-[20px] sm:w-[45%]"
        >
          With Halal Wealth, you don’t have to choose blindly. We curate the best halal opportunities and guide you step-by-step.
        </motion.p>

        <motion.div
          className="my-16 flex sm:gap-5"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <button
            onClick={() => setActiveTab('SUKUK')}
            className={`inline-block font-[500] p-2 border rounded-[32px] text-[14px] ${activeTab === 'SUKUK'
                ? 'border-[#E6DAFC] bg-[#F5F1FE] text-primary-color'
                : 'border-transparent text-[#5C556C]'
              }`}
          >
            SUKUK
          </button>
          <button
            onClick={() => setActiveTab('MURABAHA')}
            className={`inline-block font-[500] p-2 border rounded-[32px] text-[14px] ${activeTab === 'MURABAHA'
                ? 'border-[#E6DAFC] bg-[#F5F1FE] text-primary-color'
                : 'border-transparent text-[#5C556C]'
              }`}
          >
            MURABAHA
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          className="mb-8"
        >
          <h2 className="text-[20px] sm:text-[28px] font-[500] text-text-color1 mb-4">
            {activeTab === 'SUKUK' ? 'Sukuk (Islamic Bonds)' : 'Murabaha (Trade-Based Financing)'}
          </h2>
          <ul className="space-y-2">
            {descriptions[activeTab].map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-[14px] sm:text-[16px] text-text-color1">
                <CheckCircleOutlineIcon
                  style={{ fontSize: '20px', color: '#5C556C' }}
                  className="mt-1"
                />
                <span>{item.text}</span>
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          className="grid mt-16 sm:grid-cols-2 md:grid-cols-3 gap-5"
          initial="hidden"
          whileInView="visible"
          transition={{ staggerChildren: 0.2 }}
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {},
          }}
        >
          {investments[activeTab].map((investment, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: i * 0.2 }}
              viewport={{ once: true }}
            >
              <GraphCom
                name={investment.name}
                start={investment.start}
                end={investment.end}
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </FadeInSection>
  );
}

export default TopInvestment;